/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
import { isEmpty } from "lodash";
import '../../custom.css'

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import UiContent from "../../Components/Common/UiContent";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import avatar from "../../assets/images/users/user-dummy-img.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import classnames from "classnames";
import {
  GET_NOTIFICATION_LIST,
  POST_SUBSCRIBE_NOTIFICATION,
} from "../../helpers/data_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import avatar1 from "../../assets/images/users/support.png";

const notifyCustom = (msg, type) =>
  toast(msg, {
    position: "top-right",
    hideProgressBar: true,
    className: `bg-${type} text-white`,
  });
const validFileExtensions = { image: ['jpg', 'gif', 'png', 'jpeg'] };

function isValidFileType(fileName, fileType) {
  if (!fileName) {
    return true;
  }
  return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
}
const Support = () => {

  useEffect(() => {

  }, []);

  // const [preview, setPreview] = useState();

  document.title = "Support | " + process.env.REACT_APP_NAME;
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Card>
                <CardBody className="d-flex align-items-center justify-content-center flex-wrap  gap-5">
                  <img
                    style={{ width: '40%', height: '40%' }}
                    src={avatar1}
                    alt="Support Image"
                  />
                  <div className="text-center">
                    <h1 className="fs-48 mb-3">Need assistance? </h1>
                    <h2>Click the button below for support</h2>
                    <a href="https://e2y2p.share.hsforms.com/2N2sPz_eRQ8-7xu1lbkvRWw" target="_blank">
                      <Button className="mb-5 mt-3 bg-primary w-50">
                        <span className="fs-18">Get Support</span>
                      </Button>
                    </a>
                    <h4>Prefer Email ?</h4>
                    <h5 className="my-3">Please send your queries and suggestions to our inbox.</h5>
                    <a className="fs-16 fw-semibold" href="mailto:support@perfectcheck.com">support@perfectcheck.com</a>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default Support;
